import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles(theme => ({

    root: {
        height: '40%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    icon: {
        fontSize: '12rem !important',
        marginBottom: theme.spacing(6),
    },
    success: {
        color: theme.palette.success.main,
    },
    error: {
        color: theme.palette.error.main,
    },
    tagline: {
        marginTop: theme.spacing(2)
    },
    children: {
        marginTop: theme.spacing(4)
    }

}))

export const FingotiFullscreenStatus = ({ success, tagline, message, children }) => {

    const classes = useStyles();

    return (
        <div className={classes.root}>
            {
                success ?
                    <CheckCircleOutlineIcon className={clsx(classes.icon, classes.success)} />
                    :
                    <ErrorOutlineIcon className={clsx(classes.icon, classes.error)} />
            }
            <Typography variant='h3'>{tagline}</Typography>
            <Typography className={classes.tagline}>{message}</Typography>
            {
                children && 
                <div className={classes.children}>
                    {children}
                </div>
            }
        </div>
    );

}

FingotiFullscreenStatus.defaultProps = {
    success: false,
    tagline: "",
    message: ""
}

FingotiFullscreenStatus.propTypes = {
    success: PropTypes.bool,
    tagline: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired
}